var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttributeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 23,
  x: 0,
  y: 0,
  viewBox: "0 0 108 83"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 5,
  d: "M10.5 5.5h88a5 5 0 0 1 5 5v63a5 5 0 0 1-5 5h-88a5 5 0 0 1-5-5v-63a5 5 0 0 1 5-5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M103.5 5.5v26.667L75.5 5.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 5,
  d: "M103.5 5.5v26.667L75.5 5.5zM16.167 40.5c12.222 18.856 24.444-18.856 36.666 0 12.223 18.856 24.445-18.856 36.667 0"
})));
export default SvgAttributeIcon;